import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { auth } from '../../../services/firebase/firebase';
import { useHistory } from 'react-router-dom';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { authStateChange } from '../../../store/actions/userAction';

const Login = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  //   let unregisterAuthObserver;
  const uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
      {
        provider: auth.PhoneAuthProvider.PROVIDER_ID,
        defaultCountry: 'NO',
      },
    ],
    callbacks: {
      signInSuccessWithAuthResult: () => false,
    },
  };
  useEffect(() => {
    const unregisterAuthObserver = auth().onAuthStateChanged(async user => {
      await dispatch(authStateChange(user));
      if (user) history.push('/dashboard');
    });
    return function cleanup() {
      unregisterAuthObserver();
    };
  }, [dispatch, history]);

  return (
    <div className="contianer">
      <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth()} />
    </div>
  );
};

export default Login;
